import { useState, useEffect } from "react";
import { LateralNav } from "./lateralNav";

const NavbarPhone = () => {
    const [isOpen, setIsOpen] = useState(false);

    const toggleMenu = () => {
        setIsOpen(!isOpen); // Alterna entre abierto/cerrado
    };
    const scrollToSection = (id) => {
        const section = document.getElementById(id);
        if (section) {
            section.scrollIntoView({ behavior: 'smooth' });
        }
    };
    useEffect(() => {
        const scrollMenu = () => {
            const header = document.querySelector('section');
            const scrollPosition = window.pageYOffset || document.documentElement.scrollTop;

            if (scrollPosition > 1) {
                header.classList.add('tinted');
            } else {
                header.classList.remove('tinted');
            }
        };

        window.addEventListener('scroll', scrollMenu);

        return () => {
            window.removeEventListener('scroll', scrollMenu);
        };
    }, []);

    return (
        <section className="phone-navbar">
            <div className="phone-logo" onClick={() => scrollToSection('beginning')}>
                <img src='/images/logos/logoHome.png' width={50} alt="logo ABP"></img>
            </div>
            <button id="lateralNav-opener" class="lateralNav-opener" onClick={toggleMenu}>
                <div id="line-1" className={isOpen ? 'line line-open' : 'line'}></div>
                <div id="line-2" className={isOpen ? 'line line-hidden' : 'line'}></div>
                <div id="line-3" className={isOpen ? 'line line-open' : 'line'}></div>
            </button>
            {isOpen && <LateralNav></LateralNav>}
        </section>
    )
}

export default NavbarPhone;